import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronRight, Close as CloseIcon } from '@mui/icons-material';
import {
  Dialog, DialogContent, DialogTitle, IconButton,
} from '../../2-component';
import { Box, Typography } from '../../1-primative';
import { useThemeTokens } from '../../../providers/themeTokenProvider';
import { UserContext } from '../../../providers/userContextProvider';
import { translateBackend } from '../../../assets/i18n/config';
import { useGlobalToast } from '../../../providers/globalToastProvider';

export const LoginSettingModal = ({ open, setOpen }: {
  open: boolean, setOpen: (open: boolean) => void,
}) => {
  const { t } = useTranslation(['components', 'shared']);
  const { sys } = useThemeTokens();
  const { userContext, activeOrganization } = useContext(UserContext);
  const { showToast } = useGlobalToast();

  const handleClose = () => setOpen(false);

  const resetPassword = async () => {
    try {
      const data = await fetch(new Request(`https://${process.env.REACT_APP_AUTH0_DOMAIN}/dbconnections/change_password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
          email: userContext?.email,
          connection: 'Username-Password-Authentication',
        }),
      }));
      if (!data.ok) throw (new Error(`${data.status} ${data.statusText}`));
      showToast({
        message: t('components:loginSettings.resetPasswordSuccess'),
        severity: 'success',
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: `1px ${sys.color.outlineVariant} solid` }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant='headingSmall'>{translateBackend(activeOrganization.loginSettingsTitle)}</Typography>
        </Box>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          onClick={() => {
            resetPassword();
            setOpen(false);
          }}
          sx={{
            my: 1.5,
            p: 2,
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            justifyContent: 'space-between',
            border: `1px ${sys.color.outlineVariant} solid`,
            borderRadius: sys.borderRadius.lg,
          }}
        >
          <Typography variant='titleMedium'>{t('components:loginSettings.changePassword')}</Typography>
          <ChevronRight />
        </Box>
      </DialogContent>
    </Dialog>
  );
};
